import SHARED from './constants.json';

export const KENKYU_SHUBETSU = SHARED.KENKYU_SHUBETSU;
export const KENKYU_MOKEI = SHARED.KENKYU_MOKEI;
export const Representative_Class = SHARED.Representative_Class;
export const SHOZOKU_LIST = SHARED.SHOZOKU_LIST;
export const WORK_CONTENT_BY_FUND = SHARED.WORK_CONTENT_BY_FUND || {};
export const CONTENT_OPTIONS = [
  ...new Set([
    ...SHARED.CONTENT_OPTIONS,
    ...Object.values(WORK_CONTENT_BY_FUND).flatMap(rule =>
      Object.entries(rule)
        .filter(([key]) => key === "1250" || key === "1600")
        .map(([, content]) => content)
    ),
  ]),
];
export const WEEKDAYS = SHARED.WEEKDAYS;